import React, { useState } from 'react';

// KryptaMail login — the poster's "Email that outlives the quantum era" framing,
// brand mark, and the PQC chip front and center.
export function Login({ onLogin, error }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onLogin({ email, password });
    setBusy(false);
  };

  return (
    <div className="km-login">
      <div className="km-login-card">
        <div className="km-login-brand">
          <img src="/brand/mark.svg" width="48" height="48" alt="KryptaMail" />
          <div>
            <div className="km-login-wordmark">
              krypta<span>mail</span>
            </div>
            <div className="km-login-tag km-dim">Email that outlives the quantum era.</div>
          </div>
        </div>

        <div className="km-pqc-chip" style={{ marginBottom: 20 }}>
          🔐 Secured with post-quantum cryptography
        </div>

        <form onSubmit={submit} className="km-login-form">
          <label className="km-field">
            <span className="km-dim">Email</span>
            <input
              type="email" autoComplete="username" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@maurateknologi.id"
            />
          </label>
          <label className="km-field">
            <span className="km-dim">Password</span>
            <input
              type="password" autoComplete="current-password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </label>

          {error && <div className="km-login-error">⚠️ {error}</div>}

          <button type="submit" className="km-btn-primary" disabled={busy} style={{ width: '100%', marginTop: 8 }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
      <div className="km-login-foot km-faint">
        Hybrid X25519 + ML-KEM · ML-DSA signatures · on-prem
      </div>
    </div>
  );
}
